import { createApp, nextTick } from 'vue';
import { Modal} from 'mdb-ui-kit';
import { displayAction } from '@js/modules/parts/village_utils';

type Animation = {
    type: string;
    id: string;
};
const animations: Animation[] = [];

let article_modal = null;

const app = createApp({
    data: () => {
        return {
            article: null,
        };
    },
    methods: {
        showInfoModal(article) {
            this.article = article;
            const elModal = document.getElementById('article_modal');
            if(elModal){
                if (!article_modal) {
                    article_modal = new Modal(elModal);
                }
                article_modal.show();
            }
        },
    },
    // mounted() {
    //     nextTick(() => {
    //         // チケットゲットがあれば表示
    //         const ticket_modal = document.getElementById('ticket_modal');
    //         if (ticket_modal) {
    //             const a = {
    //                 type: 'modal',
    //                 id: 'ticket_modal',
    //             };
    //             animations.push(a);
    //         }
    //         // ポイント、称号ゲットなど
    //         const action_modal = document.getElementById('action_modal');
    //         if (action_modal) {
    //             const a = {
    //                 type: 'modal',
    //                 id: 'action_modal',
    //             };
    //             animations.push(a);
    //         }
    //         // 順次アニメーション
    //         if(animations.length > 0){
    //             displayAction(animations, 0);
    //         }
    //     });
    // },
});
app.mount('#app');
